import React, { useContext, useEffect, useRef, useState } from "react";
import DashboardLayout from "../../../layout/dashboard/DashboardLayout";
import TitleTextBox from "../../../fragments/TitleTextBox";
import ContainerWrapper from "../../../fragments/ContainerWrapper";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/types";
import "../../../styles/dashboard/terminals/AllRavenTerminalsIndex.css";

import { RavenButton } from "@ravenpay/raven-bank-ui";
import { useLocation, useNavigate } from "react-router-dom";
import { RouteLinks } from "../../../routes/RouteLinks";
import Icons from "../../../assets/icons/icons";
import NoContentPage from "../../../fragments/NoContentPage";
import ActionContext from "../../../context/ActionContext";
import { getAllInsights } from "../../../redux/insight";
import TabComponentProps from "./TabComponentProps";
import TabLinkComp from "../../../fragments/tab-link-comp/TabLinkComp";
import { colorToRgba } from "../../../utils/helpers";
import { useDarkMode } from "../../../utils/themes/useDarkMode";

interface ComponentProps {
  children?: React.ReactNode;
  loading?: boolean;
  noContent?: boolean;
  switchComp?: React.ReactNode;
}

const AllMerchantTerminals = ({
  children,
  loading,
  noContent,
  switchComp,
}: ComponentProps) => {
  const navigate = useNavigate();
  const [theme, toggleTheme] = useDarkMode(localStorage.getItem("theme"));
  const dispatch = useDispatch();
  const actionCtx = useContext(ActionContext);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("Physical Terminals");
  // const { loading, insights, all_virtual_terminals, loading_vir } = useSelector(
  //   (state: RootState) => state.insights
  // );

  const [activeItem, setActiveItem] = useState("");

  const listToUse = [
    {
      label: "Physical Terminals",
      value: "Physical Terminals",
      active: activeItem === "Physical Terminals",
      children: [
        {
          label: "Physical Terminals",
          value: "Physical Terminals",
          active: location?.pathname === RouteLinks?.Physical_Terminal_list,
          onClick: (param?: any) => {
            navigate(RouteLinks?.Physical_Terminal_list);
          },
        },
        {
          label: "Request History",
          value: "Request",
          active: location?.pathname === RouteLinks?.AllRequested_Terminal,
          onClick: (param?: any) => {
            navigate(RouteLinks?.AllRequested_Terminal);
          },
        },
      ],
    },
    {
      label: "Virtual Terminals",
      value: "Virtual Terminals",
      active: location.pathname === RouteLinks?.Terminal_Virtual_List,
      onClick: (param?: any) => {
        navigate(RouteLinks?.Terminal_Virtual_List);
      },
    },
    // {
    //   label: "Request History",
    //   value: "Request",
    //   active: location?.pathname === RouteLinks?.AllRequested_Terminal,
    //   onClick: (param?: any) => {
    //     navigate(RouteLinks?.AllRequested_Terminal);
    //   },
    // },
  ];

  return (
    <>
      <DashboardLayout>
        <TitleTextBox
          title="Terminals"
          text="Manage Bankbox devices on the platform"
        >
          <RavenButton
            color="deep-green-light"
            label="Request Terminal"
            style={{ marginLeft: "auto", zIndex: "0" }}
            onClick={() => navigate(RouteLinks.Request_Terminal)}
          />
        </TitleTextBox>

        <ContainerWrapper
          noContent={noContent}
          noContentLoading={loading}
          // loading={true}
          width="100%"
          dontShowHeader
        >
          <div className="all-merchant-terminal-main-wrap-index">
            {/* reusable tab start */}
            <TabLinkComp
              activeBgColor={colorToRgba("var(--primary-base-color)", 0.1)}
              activeColor="var(--primary-base-color)"
              list={listToUse}
              defaultColor={theme === "light" ? "#020202" : "#ffffff"}
              // hideSelected
              // showParentSelected
              className="tab-link-box-wrappper-index"
            /> 
            {/* reusable tab end */}
            {/* Main content area */}
            <div className="main-content-box-wrapper">{children}</div>
            {/* main content here end */}
          </div>
          {/* content here end */}
        </ContainerWrapper>
      </DashboardLayout>
    </>
  );
};

export default AllMerchantTerminals;
